module.exports = __webpack_public_path__ + "static/img/6.ccaa137.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/zh/6.png
// module id = 34DW
// module chunks = 0